export default __webpack_public_path__ + "static/media/FELIPE_olivares.42bcdaf2.png";